export default __webpack_public_path__ + "static/media/logo-universe.131d9abf.png";